import { render, staticRenderFns } from "./TheModalRegistro.vue?vue&type=template&id=bd7fbfd4&scoped=true&"
import script from "./TheModalRegistro.vue?vue&type=script&lang=js&"
export * from "./TheModalRegistro.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7fbfd4",
  null
  
)

export default component.exports